import * as Sentry from '@sentry/react';
import env from 'utils/env';
import pkg from '../../package.json';

const getRelease = () => `payment-frontend@${pkg.version}`;

if ((process.env.NX_SENTRY_DSN?.length ?? 0) !== 0) {
  Sentry.init({
    dsn: env.get('SENTRY_DSN'),
    environment: env.getServer(),
    release: getRelease(),
  });
}
